import React from 'react';
import Icon from './Icon';
import { purpose } from '../data';

export default function Purpose() {
  return (
    <section className="section section--tight" id="impact">
      <div className="container">
        <div className="purpose">
          <h2 className="purpose__title">
            Together, we exist to spread <span className="grad-pink">Joy</span>
          </h2>
          <p className="purpose__sub">Our DNA</p>
          <div className="purpose__grid">
            {purpose.map((p) => (
              <div className="purpose__item" key={p.title}>
                <span className="purpose__icon" style={{ color: p.color }}>
                  <Icon name={p.icon} size={26} />
                </span>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
